import React, { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import axios from "axios";
import Snackbar from "@mui/material/Snackbar";

const apiUrl = process.env.REACT_APP_API_URL;

export default function DevisDialog({ visible, onHide, leadData, onDevisGenerated }) {
  const [formule, setFormule] = useState("avec_alcool");
  const [prixParPersonne, setPrixParPersonne] = useState(20);
  const [remise, setRemise] = useState(0);
  const [generating, setGenerating] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [devisInfo, setDevisInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [nbPersonnes, setNbPersonnes] = useState(leadData?.nbpers || 0);
  const [nbBarmen, setNbBarmen] = useState(1);
  const [structure, setStructure] = useState("tuk_tuk");
  const [options, setOptions] = useState([]);

  // Calculs
  const sousTotalPrestation = nbPersonnes * prixParPersonne;
  const sousTotalOptions = options.reduce((sum, opt) => sum + (opt.prix || 0), 0);
  const sousTotal = sousTotalPrestation + sousTotalOptions;
  const montantRemise = (sousTotal * remise) / 100;
  const total = sousTotal - montantRemise;

  useEffect(() => {
    if (leadData?.nbpers) setNbPersonnes(leadData.nbpers);
  }, [leadData]);

  useEffect(() => {
    if (visible && leadData?.idLead) checkExistingDevis();
  }, [visible, leadData]);

  
const checkExistingDevis = async () => {
  setLoading(true);
  setDevisInfo(null);
  try {
    const response = await axios.get(`${apiUrl}/IHM/api/generer_devis.php?lead_id=${leadData.idLead}`);
    if (response.data.a_devis == 1) {  
      setDevisInfo({
        a_devis: response.data.a_devis,
        numero_devis: response.data.dernier_devis_id,
        lien_devis: response.data.lien_devis,
        lien_pdf: response.data.lien_pdf,
        token_devis: response.data.token_devis,
        montant_devis: response.data.montant_total || 0,
        date_devis: response.data.date_devis || new Date().toISOString(),
        idVosFactures: response.data.idVosFactures,
        statut_devis: response.data.statut_devis || "brouillon",
      });
    } else {
      setDevisInfo(null);
    }
  } catch (error) {
    console.error(error);
  } finally {
    setLoading(false);
  }
};

  const handleCloseSnackbar = () => setOpenSnackbar(false);

  const ajouterOption = () => {
    setOptions([...options, { titre: "", description: "", prix: 0 }]);
  };

  const supprimerOption = (index) => {
    const newOptions = [...options];
    newOptions.splice(index, 1);
    setOptions(newOptions);
  };

  const modifierOption = (index, champ, valeur) => {
    const newOptions = [...options];
    newOptions[index][champ] = valeur;
    setOptions(newOptions);
  };

  const handleGenererDevis = async () => {
    if (!leadData) return;
    setGenerating(true);
    try {
      const response = await axios.post(`${apiUrl}/IHM/api/generer_devis.php`, {
        lead_id: leadData.idLead,
        nom: leadData.nomPrenom,
        email: leadData.email,
        tel: leadData.tel,
        lieu: leadData.lieu,
        nb_personnes: nbPersonnes,
        nb_barmen: nbBarmen,
        formule: formule,
        prix_par_personne: prixParPersonne,
        remise: remise,
        structure: structure,
        options: options,
        adminMod: localStorage.getItem("us"),
      });
      
      if (response.data.success) {
        // setDevisInfo({
        //   a_devis: 1,
        //   lien_devis: response.data.devis_url,
        //   lien_pdf: response.data.pdf_url,
        //   numero_devis: response.data.devis_number,
        //   montant_devis: response.data.montant
        // });
        checkExistingDevis();
        
        setSnackbarMessage("Devis généré avec succès !");
        setOpenSnackbar(true);
        if (onDevisGenerated) onDevisGenerated();

        // setTimeout(() => {
        //   onHide();
        //   resetForm();
        // }, 2000);

      } else {
        setSnackbarMessage(response.data.message || "Erreur");
        setOpenSnackbar(true);
      }
    } catch (error) {
      setSnackbarMessage("Erreur lors de la génération");
      setOpenSnackbar(true);
    } finally {
      setGenerating(false);
    }
  };

  const resetForm = () => {
    setFormule("avec_alcool");
    setPrixParPersonne(20);
    setRemise(0);
    setNbPersonnes(leadData?.nbpers || 0);
    setNbBarmen(1);
    setStructure("tuk_tuk");
    setOptions([]);
  };

  // Styles pour supprimer le ring bleu
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      .p-inputtext:enabled:focus, .p-inputtext:focus {
        box-shadow: none !important;
        outline: none !important;
        border-color: #ced4da !important;
      }
      input:focus {
        outline: none !important;
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  const header = (
    <div className="flex justify-content-between align-items-center w-full">
      <span className="font-semibold text-lg">
        {devisInfo?.a_devis ? "Devis existant" : "Générer un devis"}
      </span>
    </div>
  );

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        message={snackbarMessage}
        action={
          <IconButton
            size="small"
            color="inherit"
            onClick={handleCloseSnackbar}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      />

      <Dialog
        blockScroll
        visible={visible}
        header={header}
        className="custom-dialog"
        style={{ width: "45vw", maxWidth: "700px" }}
        modal
        onHide={() => {
          onHide();
          resetForm();
        }}
        breakpoints={{ "960px": "90vw", "640px": "95vw" }}
      >
        <div className="p-3">
          {/* Infos client */}
          <div className="grid">
            <div className="col-12 md:col-6">
              <div className="p-2 px-0 surface-100 border-round-sm flex justify-content-between align-items-center">
                <span className="font-bold">Client :</span>
                <span>{leadData?.nomPrenom || "-"}</span>
              </div>
            </div>
            <div className="col-12 md:col-6">
              <div className="p-2 px-0 surface-100 border-round-sm flex justify-content-between align-items-center">
                <span className="font-bold">Téléphone :</span>
                <span>{leadData?.tel || "-"}</span>
              </div>
            </div>
            <div className="col-12">
              <div className="p-2 px-0 surface-100 border-round-sm flex justify-content-between align-items-center">
                <span className="font-bold">Email :</span>
                <span>{leadData?.email || "-"}</span>
              </div>
            </div>
          </div>

          {loading ? (
            <div className="flex justify-content-center p-5">
              <i
                className="pi pi-spin pi-spinner"
                style={{ fontSize: "2rem", color: "#2563eb" }}
              ></i>
            </div>
          ) : !devisInfo?.a_devis ? (
            <>
              {/* Nombre de personnes et barmans */}
              <div className="grid mt-2">
                <div className="col-12 md:col-6">
                  <div className="p-2 px-0 surface-100 border-round-sm flex justify-content-between align-items-center">
                    <span className="font-bold">Nb personnes :</span>
                    <div className="flex align-items-center gap-2">
                      <input
                        type="number"
                        value={nbPersonnes}
                        onChange={(e) =>
                          setNbPersonnes(parseInt(e.target.value) || 0)
                        }
                        min={1}
                        max={1000}
                        style={{
                          width: "80px",
                          height: "35px",
                          padding: "8px",
                          borderRadius: "5px",
                          border: "1px solid #ced4da",
                        }}
                      />
                      <span className="text-sm text-gray-500">
                        (Fiche: {leadData?.nbpers || 0})
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-12 md:col-6">
                  <div className="p-2 px-0 surface-100 border-round-sm flex justify-content-between align-items-center">
                    <span className="font-bold">Nb barmans :</span>
                    <input
                      type="number"
                      value={nbBarmen}
                      onChange={(e) =>
                        setNbBarmen(parseInt(e.target.value) || 1)
                      }
                      min={1}
                      max={10}
                      style={{
                        width: "80px",
                        height: "35px",
                        padding: "8px",
                        borderRadius: "5px",
                        border: "1px solid #ced4da",
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* Structure */}
              <div className="grid mt-2">
                <div className="col-12">
                  <div className="p-2 px-0 surface-100 border-round-sm flex justify-content-between align-items-center">
                    <span className="font-bold">Structure :</span>
                    <Select
                      value={structure}
                      onChange={(e) => setStructure(e.target.value)}
                      size="small"
                      sx={{ minWidth: 200 }}
                      MenuProps={{
                        container: document.body,
                        style: { zIndex: 9999 },
                      }}
                    >
                      <MenuItem value="tuk_tuk">Le Tuk-Tuk Bar</MenuItem>
                      <MenuItem value="elegance">Le Bar Élégance</MenuItem>
                      <MenuItem value="both">
                        Le Tuk-Tuk Bar & Le Bar Élégance
                      </MenuItem>
                    </Select>
                  </div>
                </div>
              </div>

              {/* Formule, Prix et Remise */}
              <div className="grid mt-2">
                <div className="col-12 md:col-4">
                  <div className="p-2 px-0 surface-100 border-round-sm flex justify-content-between align-items-center">
                    <span className="font-bold">Formule :</span>
                    <Select
                      value={formule}
                      onChange={(e) => setFormule(e.target.value)}
                      size="small"
                      sx={{ minWidth: 140 }}
                      MenuProps={{
                        container: document.body,
                        style: { zIndex: 9999 },
                      }}
                    >
                      <MenuItem value="avec_alcool">Avec alcool</MenuItem>
                      <MenuItem value="sans_alcool">Sans alcool</MenuItem>
                    </Select>
                  </div>
                </div>
                <div className="col-12 md:col-4">
                  <div className="p-2 px-0 surface-100 border-round-sm flex justify-content-between align-items-center">
                    <span className="font-bold">Prix / pers (€) :</span>
                    <input
                      type="number"
                      value={prixParPersonne}
                      onChange={(e) =>
                        setPrixParPersonne(parseFloat(e.target.value) || 0)
                      }
                      min={0}
                      step={1}
                      style={{
                        width: "80px",
                        height: "35px",
                        padding: "8px",
                        borderRadius: "5px",
                        border: "1px solid #ced4da",
                      }}
                    />
                  </div>
                </div>
                <div className="col-12 md:col-4">
                  <div className="p-2 px-0 surface-100 border-round-sm flex justify-content-between align-items-center">
                    <span className="font-bold">Remise (%) :</span>
                    <input
                      type="number"
                      value={remise}
                      onChange={(e) =>
                        setRemise(parseFloat(e.target.value) || 0)
                      }
                      min={0}
                      max={100}
                      step={1}
                      style={{
                        width: "100px",
                        height: "35px",
                        padding: "8px",
                        borderRadius: "5px",
                        border: "1px solid #ced4da",
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* Options supplémentaires */}
              <div className="grid mt-2">
                <div className="col-12">
                  <div className="p-2 px-0 border-round-sm flex justify-content-between align-items-center">
                    <span className="font-bold">Options :</span>
                    <Button
                      label="Ajouter une option"
                      icon="pi pi-plus"
                      className="p-button-sm text-white"
                      style={{
                        background: "#2563eb",
                        border: "none",
                        padding: "0.5rem 1rem",
                        borderRadius: "5px",
                      }}
                      onClick={ajouterOption}
                    />
                  </div>
                </div>
              </div>

              {options.map((option, index) => (
                <div key={index} className="grid mt-1">
                  <div className="col-12 md:col-4">
                    <InputText
                      value={option.titre}
                      onChange={(e) =>
                        modifierOption(index, "titre", e.target.value)
                      }
                      placeholder="Titre"
                      className="w-full"
                      style={{ height: "35px" }}
                    />
                  </div>
                  <div className="col-12 md:col-5">
                    <InputText
                      value={option.description}
                      onChange={(e) =>
                        modifierOption(index, "description", e.target.value)
                      }
                      placeholder="Description"
                      className="w-full"
                      style={{ height: "35px" }}
                    />
                  </div>
                  <div className="col-12 md:col-2">
                    <input
                      type="number"
                      value={option.prix}
                      onChange={(e) =>
                        modifierOption(
                          index,
                          "prix",
                          parseFloat(e.target.value) || 0,
                        )
                      }
                      placeholder="Prix"
                      min={0}
                      step={1}
                      style={{
                        width: "100%",
                        height: "35px",
                        padding: "8px",
                        borderRadius: "5px",
                        border: "1px solid #ced4da",
                      }}
                    />
                  </div>
                  <div className="col-12 md:col-1">
                    <Button
                      icon="pi pi-trash"
                      className="p-button-danger p-button-text p-button-sm"
                      onClick={() => supprimerOption(index)}
                    />
                  </div>
                </div>
              ))}

              {/* Calcul du prix */}
              <div className="grid mt-3">
                <div className="col-12">
                  <div
                    className="p-2 px-0 border-round-sm"
                    style={{ background: "#e5e7eb", borderRadius: "5px" }}
                  >
                    <div className="flex justify-content-between py-1">
                      <span>
                        Prestation ({nbPersonnes} x {prixParPersonne}€)
                      </span>
                      <span>{sousTotalPrestation.toFixed(2)} €</span>
                    </div>
                    {options.map(
                      (opt, idx) =>
                        opt.prix > 0 && (
                          <div
                            key={idx}
                            className="flex justify-content-between py-1"
                          >
                            <span>{opt.titre || "Option"}</span>
                            <span>{opt.prix.toFixed(2)} €</span>
                          </div>
                        ),
                    )}
                    <div className="flex justify-content-between pt-2 border-top-1 font-bold">
                      <span>Sous-total</span>
                      <span>{sousTotal.toFixed(2)} €</span>
                    </div>
                    {remise > 0 && (
                      <div className="flex justify-content-between py-1 text-red-500">
                        <span>Remise ({remise}%)</span>
                        <span>- {montantRemise.toFixed(2)} €</span>
                      </div>
                    )}
                    <div className="flex justify-content-between pt-2 border-top-1 font-bold text-lg">
                      <span>Total TTC</span>
                      <span>{total.toFixed(2)} €</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Bouton générer */}
              <div className="grid mt-3">
                <div className="col-12">
                  <Button
                    label={generating ? "Génération..." : "Générer le devis"}
                    icon={
                      generating ? "pi pi-spin pi-spinner" : "pi pi-file-pdf"
                    }
                    className="w-full text-white"
                    style={{
                      background: "#2563eb",
                      border: "none",
                      padding: "0.75rem",
                      borderRadius: "5px",
                    }}
                    onClick={handleGenererDevis}
                    disabled={generating || nbPersonnes === 0}
                  />
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="grid mt-3">
                <div className="col-12">
                  <div
                    className="p-3 border-round-sm"
                    style={{ background: "#f9fafb", borderRadius: "5px" }}
                  >
                    <div className="flex justify-content-between align-items-center mb-2">
                      <span className="font-bold">Devis N° :</span>
                      <span>{devisInfo.numero_devis}</span>
                    </div>
                    <div className="flex justify-content-between align-items-center mb-2">
                      <span className="font-bold">Date de création :</span>
                      <span>
                        {new Date(devisInfo.date_devis).toLocaleDateString(
                          "fr-FR",
                        )}
                      </span>
                    </div>
                    <div className="flex justify-content-between align-items-center mb-2">
                      <span className="font-bold">Montant total :</span>
                      <span>
                        {parseFloat(devisInfo.montant_devis).toFixed(2)} €
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="grid mt-3">
                <div className="col-12">
                  <div className="flex gap-2 justify-content-center flex-wrap">
                    {devisInfo.lien_pdf && (
                      <Button
                        label="PDF"
                        severity="danger"
                        icon="pi pi-download"
                        onClick={() =>
                          window.open(devisInfo.lien_pdf, "_blank")
                        }
                      />
                    )}
                    {devisInfo.lien_devis && (
                      <Button
                        label="Voir"
                        icon="pi pi-eye"
                        severity="info"
                        onClick={() =>
                          window.open(devisInfo.lien_devis, "_blank")
                        }
                      />
                    )}
                    <Button
                      label="Modifier"
                      severity="warning"
                      icon="pi pi-pencil"
                      onClick={() =>
                        window.open(
                          `https://unptittukenplus.vosfactures.fr/invoices/${devisInfo.idVosFactures}/edit`,
                          "_blank",
                        )
                      }
                    />
                    <Button
                      label="Envoyer le devis"
                      icon="pi pi-envelope"
                      severity="success"
                      onClick={() => {
                        axios
                          .post(`${apiUrl}/IHM/api/sendMailDevis.php`, {
                            id: leadData.idLead,
                            adminMod: localStorage.getItem("us"),
                          })
                          .then((res) => {
                            if (res.data.success) {
                              setSnackbarMessage(
                                `Le devis a bien été envoyé à ${leadData.email}`,
                              );
                              setOpenSnackbar(true);

                              setDevisInfo({
                                ...devisInfo,
                                statut_devis: "envoye",
                              });
                            } else {
                              setSnackbarMessage(
                                res.data.message || "Envoi impossible",
                              );
                              setOpenSnackbar(true);
                            }
                          })
                          .catch((err) => {
                            console.error("Erreur envoi mail:", err);
                            setSnackbarMessage("Impossible d'envoyer le mail");
                            setOpenSnackbar(true);
                          });
                      }}
                    />
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </Dialog>
    </>
  );
}